import { type PropsWithChildren } from 'react'

import { cn } from '@/lib/utils'

export interface CHeaderWrapperProps {
  className?: string
}

export const HeaderWrapper = ({ children, className }: PropsWithChildren<CHeaderWrapperProps>) => {
  return (
    <div
      className={cn(
        'hidden lg:flex lg:flex-col',
        'relative',
        'before:absolute before:inset-0 before:z-[-1]',
        'before:h-full before:w-screen',
        'before:-left-[50vw] before:ml-[50%] before:bg-slate-700',
        className
      )}
    >
      {children}
    </div>
  )
}
